import styled from 'styled-components';

export const ProgressVolumeBar = styled.div`
  display: flex;
  width: 8rem;
  box-shadow: ${({ theme }) => theme.commoms.boxShadow};

  & > div {
    height: 1rem;
    text-align: center;
    color: ${({ theme }) => theme.colors.white};
    font-size: 0.75rem;

    &:first-child {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
    }

    &:last-child {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }

    &.pending {
      background-color: ${({ theme }) => theme.colors.grayStatus};
      color: unset;
    }

    &.delivery {
      background-color: ${({ theme }) => theme.colors.statusOrange};
    }

    &.shipment {
      background-color: ${({ theme }) => theme.colors.statusBlue};
    }

    &.billed {
      background-color: ${({ theme }) => theme.colors.statusGreen};
    }

    &.cancelled {
      background-color: ${({ theme }) => theme.colors.red};
    }
  }
`;

export const VolumeTotal = styled.span`
  font-size: 0.625rem;
`;
